import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';

import { AuthService } from '../../shared/services/auth.service';
import { ContractService } from '../../shared/services/contract.service';

import { LoginModel } from '../../shared/models/login.model';
import { ConsultaLista } from '../../shared/models/consulta-lista.model';
import { Lista } from '../../shared/models/lista.model';
import { CacheService } from '../../shared/models/cache-service.model';
import { SessionService } from '../../shared/services/session.service';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-login-mp',
  templateUrl: './login-mp.component.html',
  styleUrls: ['./login-mp.component.css']
})
export class LoginMpComponent implements OnInit {

  showSpinner: boolean;
  
    login: LoginModel; 
  
    constructor(
      private _route: ActivatedRoute,
      private _router: Router,
      private _authService: AuthService,
      private _sessionService: SessionService,
      private _contractService: ContractService,
      private _userService: UserService
    ) {
      this.login = new LoginModel("", "");
      
      if(environment.production){
        if(window.location.href !== 'http://web.medplus.net.co:8778/sucursal_web/auth/mp_access'){
          this._router.navigate(['/auth/sign_in']);                    
        }

      }      
   
    }
   
  
    ngOnInit() {
      this.showSpinner = false; 
      swal.close();   
    }
  
    onSubmit(token : string) {
  
      this.showSpinner = true;
  
      this._authService.logInAccessMP({'username': this.login.user, 'password': this.login.pass }).subscribe(
        res => { 

          this._sessionService.setCurrentUserManagement(res);

          this._router.navigate(['/office_management']);
          
        },
        err => {
  
          this.showSpinner = false;
  
          if (err.status === 401 || err.status === 500) {
            swal({
              title: 'Autenticación',
              html: '<p style="font-size:14px">' + err.error.message + '</p>',
              type: err.error.type,
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false
            });  
          } else {
            swal({
              title: 'Autenticación',
              html: '<p style="font-size:14px">Ingreso No Autorizado</p>',
              type: 'error',
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false
            });
          }
        }
      );
  
    }  
  
  }
  


// WEBPACK FOOTER //
// /app/src/app/auth/login-mp/login-mp.component.ts